import script from "./Signature.vue?vue&type=script&setup=true&lang=js"
export * from "./Signature.vue?vue&type=script&setup=true&lang=js"

import "./Signature.vue?vue&type=style&index=0&id=ba8558ba&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba8558ba"]])

export default __exports__